module.exports = __webpack_public_path__ + "img/logo-default.5ffeb19e.png";